import React from 'react'

export const UserRoleTableHead = () => {
  return (
    <div className="user-table--row user-table--head">
    <div className="user-table--cell fixed">
      <p>Title</p> 
    </div>
    <div className="detail-block">
    <div className="user-table--cell">
      <p>Assigned by</p> 
    </div>
    <div className="user-table--cell">
      <p>Udførelsesdato</p> 
    </div>
    <div className="user-table--cell">
      <p>Deadline Date</p> 
    </div>
    </div>
  </div>
  )
}
export default UserRoleTableHead;